module.exports = __webpack_public_path__ + "img/settings_640.5fe01a70.png";